import type { RequestQuery } from '../common';
import type { UseAccountParams } from './types';

export const getAccountsKey = () => ['accounts'] as const;

export const getAccountListQueryKey = (query?: RequestQuery) =>
  [...getAccountsKey(), 'list', query] as const;

export const getAccountQueryKey = (params: UseAccountParams) =>
  [...getAccountsKey(), 'account', params] as const;
